import * as React from 'react';
import { v4 } from 'uuid';
import Styled from 'styled-components';

import { IRadioCardProps, RadioCardContent, RadioInput } from './RadioCommon';

export const RadioCardDataPointContainer = Styled.div`
  /* IE11 Support */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    justify-content: unset;
    flex-wrap: unset;
  }
`;

export const RadioCardDataPoint = Styled.div`
  display: flex;
  flex-direction: column;
`;

export default class RadioCard extends React.PureComponent<IRadioCardProps> {
  private readonly _id: string = v4();

  public render () {
    const { children, id, alert, ...restProps } = this.props;

    return (
      <>
        <RadioInput
          {...restProps}
          id={this._id}
          data-id={id}
          aria-checked={restProps.checked}
          type='radio'
        />
        <RadioCardContent alert={alert} htmlFor={this._id} data-id={id}>
          {children}
        </RadioCardContent>
      </>
    );
  }
}
